import React from 'react';
import { motion } from 'framer-motion';
export function FloatingCTA() {
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    delay: 2,
    duration: 0.5,
    ease: 'easeOut'
  }} className="fixed bottom-6 inset-x-0 z-50 pointer-events-none flex justify-center" data-id="element-91">
      <motion.a href="#oferta" animate={{
      scale: [1, 1.06, 1]
    }} transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.95
    }} className="pointer-events-auto bg-green-600 hover:bg-green-700 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-[0_4px_20px_rgba(22,163,74,0.5)] flex items-center gap-2 transition-colors" data-id="element-92">
        🍿 ¡COMPRAR AHORA! — $6.900
      </motion.a>
    </motion.div>;
}